/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerExportToExcelQueryResponse, TemplatesControllerExportToExcelPathParams } from "../../models/checklistsController/TemplatesControllerExportToExcel";

function getTemplatesControllerExportToExcelUrl(id: TemplatesControllerExportToExcelPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-templates/${id}/excel` as const }  
  return res
}

/**
 * @description Generates a multi-tab Excel file containing the checklist template with sections, answer types, questions, and prompts.
 * @summary Export checklist template to Excel
 * {@link /api/v1/checklist-templates/:id/excel}
 */
export async function templatesControllerExportToExcel(id: TemplatesControllerExportToExcelPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerExportToExcelQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTemplatesControllerExportToExcelUrl(id).url.toString(), ... requestConfig })  
  return res.data
}